import React, { useEffect, useState } from "react";
import { useAuthStore } from "./store/authStore";
import { useOptInStore } from "./store/optInStore";
import QuickUserGuideDialog, { QUICK_USERS_GUIDE_OPT_IN } from "./QuickUserGuideDialog";

// Mounted once inside LicenseGuard, so it only runs for a user who is both
// authenticated and past the license gate (never on the login/license pages
// themselves). Checks the quick_users_guide opt-in once per mount and pops
// the dialog open if the user hasn't dismissed it with "Don't show this
// again" on some earlier login.
const QuickUserGuideAutoShow = () => {
  const user = useAuthStore((state) => state.user);
  const fetchOptIn = useOptInStore((state) => state.fetchOptIn);
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const email = user?.email || user?.id;
    if (!email || checked) return;
    setChecked(true);
    fetchOptIn(QUICK_USERS_GUIDE_OPT_IN, email).then((dismissed) => {
      if (!dismissed) setOpen(true);
    });
  }, [user, checked, fetchOptIn]);

  return <QuickUserGuideDialog open={open} onClose={() => setOpen(false)} />;
};

export default QuickUserGuideAutoShow;
